 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		67: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		67: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","5":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","7":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~magic-apron","10":"aisle-bay~buybox","11":"buybox~promotion-products-lazy","12":"buybox~quick-view","13":"buybox~super-sku","14":"promotion-products-lazy~quick-view","15":"promotion-products-lazy~ratings-and-reviews","16":"ratings-and-reviews-mobile","17":"StoreLayout","18":"add-to-list-drawer","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"common","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"emt-questions-and-answers-component","37":"fbr","38":"global-custom-configurator","39":"hammerjs","41":"home","42":"magic-apron","43":"measurement-guide","44":"measurement-guide-overlay-content","45":"media-gallery-filmstrip-mobile","46":"media-gallery-overlay","47":"media-gallery-overlay-mobile","48":"orange-lens","49":"order-sample","50":"order-sample-drawer","51":"overlay","52":"paint-reorder","53":"paint-reorder-mobile","54":"pep","55":"pep-mobile","56":"product","57":"product-mobile","58":"product-overview","59":"promotion-products-lazy","60":"question","61":"questions-and-answers","62":"quick-view","63":"ratings-and-reviews","64":"ratings-and-reviews-desktop","65":"results","66":"returns-messaging","68":"share-to-email-overlay","69":"share-to-pinterest-overlay","70":"size-guide-overlay","71":"specifications","72":"stylequiz","73":"super-sku","74":"vendor-collection-products","75":"vendor-collections","76":"vendor-collections-mobile","78":"video-player","79":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"92333c3cc21c21e66dd8","1":"818749614a0f9b44cf2b","2":"3fbe2f69e5947c5e10e8","3":"08a8e2079c4712637807","4":"7c26827f1561d6b76340","5":"ba15b45c93c43ea334f9","6":"87cc423144a3a2a05637","7":"01a1d2760282682af29a","8":"be05bd78e7d49a9fe32d","9":"f0386245db538d64246b","10":"10f3b6777ada828943af","11":"412b34f9f9f4103bd9b4","12":"dac3f1d8420a0dfc6c74","13":"df1b93554e16eaa1d04c","14":"5593bf4a8563fa306bb5","15":"b5ba246d918bc8c0c04c","16":"4c05b3be5e1394ef427f","17":"b0a6449853da09a8cbc5","18":"1f02e231bb700f523408","19":"ac2fc1c2190356a8148e","20":"261426d3cd429fcb37eb","21":"ad15d5ba2f03c90e5b2f","22":"87f88ceb08ba0cbd9888","23":"c0e3ca473bf0bccac393","24":"03d918c40e5f40800c4d","25":"5e11997fce8fa06a5f58","26":"3125d1d6edfcc92638c2","27":"e71add859b826e5700cd","28":"3733dd453edd26d082ca","29":"4b7bb4e24d026f30843e","30":"533e27c5bb4b40727277","31":"58edc51db2eeeb4ad19c","32":"fcee5dafc3a54b7e5d8f","33":"90d2562cbf2b239e83d6","34":"2071b0f60d700de0fcff","35":"04f59ba5c4d1598bb361","36":"45e865e0b352df5aa0fe","37":"e6c3344e8e01b07fc2c8","38":"5e05d5ac96827d13474c","39":"81a134850ce14f6a1aa2","41":"95b30e871cf07056a51e","42":"eeb6513a61530f53a682","43":"31bed97199dd329ecdab","44":"b2d9aa59f806f0d4f064","45":"ef306f2b637115fde23e","46":"9b593e6cdd1bc304ef45","47":"0de29f551d79686744f0","48":"3a2c883fa98f4fdb882d","49":"8c66b3ec3cd4d351e57a","50":"f9d928bb90d9cdeb3d13","51":"bd53130277c72d911e84","52":"562a74bf76b52c45f0f9","53":"2a5c28ffb59dc4874e33","54":"48825a77ac79a959ef2a","55":"55a6c96f7a585a395ba5","56":"1b3e9598e693e30f2aee","57":"a3185e9eafe62485bc36","58":"f2e07d11170ac8d58ece","59":"f8face8d3583d933570e","60":"2ff5291f9499311896e8","61":"25c01cb00c2670577938","62":"e319060ea835847b4053","63":"53733225ad04e75fcbb5","64":"d6a3ad4898ba944540da","65":"584c6992f08a8deeb9ee","66":"dc2bd12bca0824f53be0","68":"1e8c9af0704f506a6ddd","69":"d82b6247e9cd6dfaaddb","70":"3ccb3bfaceb6d0737933","71":"5b814590d2c0e1130214","72":"ff58d8e16a42ce414717","73":"6b5748a6b084bc8db22b","74":"3226fd19758ae785042b","75":"c55a89ae66272b24c9b1","76":"2797409140a9bc9cf094","78":"20788d7f56032456d583","79":"00f4a0682f680f537bdb","80":"7960e23ce27fd7ff0a2f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"4":1,"5":1,"6":1,"7":1,"8":1,"12":1,"13":1,"15":1,"16":1,"19":1,"23":1,"24":1,"25":1,"27":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"42":1,"45":1,"46":1,"47":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"61":1,"62":1,"70":1,"72":1,"73":1,"74":1,"75":1,"76":1,"79":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","5":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","7":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~magic-apron","10":"aisle-bay~buybox","11":"buybox~promotion-products-lazy","12":"buybox~quick-view","13":"buybox~super-sku","14":"promotion-products-lazy~quick-view","15":"promotion-products-lazy~ratings-and-reviews","16":"ratings-and-reviews-mobile","17":"StoreLayout","18":"add-to-list-drawer","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"common","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"emt-questions-and-answers-component","37":"fbr","38":"global-custom-configurator","39":"hammerjs","41":"home","42":"magic-apron","43":"measurement-guide","44":"measurement-guide-overlay-content","45":"media-gallery-filmstrip-mobile","46":"media-gallery-overlay","47":"media-gallery-overlay-mobile","48":"orange-lens","49":"order-sample","50":"order-sample-drawer","51":"overlay","52":"paint-reorder","53":"paint-reorder-mobile","54":"pep","55":"pep-mobile","56":"product","57":"product-mobile","58":"product-overview","59":"promotion-products-lazy","60":"question","61":"questions-and-answers","62":"quick-view","63":"ratings-and-reviews","64":"ratings-and-reviews-desktop","65":"results","66":"returns-messaging","68":"share-to-email-overlay","69":"share-to-pinterest-overlay","70":"size-guide-overlay","71":"specifications","72":"stylequiz","73":"super-sku","74":"vendor-collection-products","75":"vendor-collections","76":"vendor-collections-mobile","78":"video-player","79":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2134e3f2525f4b18b82f","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"89d9163eeb30e835d559","5":"fd5b0df9636559fa8ba8","6":"5a3833afc72235585445","7":"0ef658ad0521bc70e648","8":"65f1d7aedc445dc5836f","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"88078be229242eb84276","13":"20f2aced33e6b1ed7b41","14":"31d6cfe0d16ae931b73c","15":"9d02d79dc9b8f52f7762","16":"2ade42f7647d0b013747","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"d94b956aa532c1a50c65","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"eb3d9ff8cd6245db8bec","24":"d96322ee912fcfb69564","25":"03a17a550cca64bbf44f","26":"31d6cfe0d16ae931b73c","27":"e6603e9d3f3a3d958705","28":"5c11f33cda0f1f9dde2a","29":"31d6cfe0d16ae931b73c","30":"4f53b9dd32b3e25e3702","31":"b71f8ffaebe49e5b8650","32":"c466036523aec2558c34","33":"5521673608a60d69edf8","34":"b49004ddac99adec2224","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"88e24c7aafcf93ae6cc6","38":"1a5562a08d12f7682989","39":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"4be99b2862037eff2a09","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"a3d0306b84dd9d80e2af","46":"0d8804fbcad988021ef3","47":"6d809e5b8b60e4c3e192","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"0fa6cf758a5b3c36b306","52":"c9fb5a26762644840358","53":"76a90382a2f70e30fe68","54":"54e4b8075e5ea32075c0","55":"9d73c156b77634e107cf","56":"471908aae13a173c69b8","57":"42e11a93701bdb1efdb7","58":"be155bb5d11dacdc4bb8","59":"3d0034667fc7d24314e6","60":"31d6cfe0d16ae931b73c","61":"d70c859b20e57c1599c5","62":"d4ead29021512beb3109","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"453dfc2640779a848cc6","71":"31d6cfe0d16ae931b73c","72":"80dd5e6aa68c9fbca3f8","73":"b31101625f385d3bcc30","74":"e518e335254638969e62","75":"65219abb9c80e0413c99","76":"8a76f2f9841966182cfc","78":"31d6cfe0d16ae931b73c","79":"174fe682162bc23ff958","80":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
